import React from "react";
import { Check } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
const plans = [{
  name: "Basic",
  price: "$50",
  period: "/year",
  description: "Essential analysis for the independent investor.",
  features: ["Independent investment ideas", "Market analysis", "Standard email support"],
  isPopular: false,
  buttonText: "Select Basic",
  buttonVariant: "ghost" as const
}, {
  name: "Premium",
  price: "$99",
  period: "/year",
  description: "Full access to high-conviction calls and research.",
  features: ["High-conviction crypto calls", "High-conviction equities calls", "Priority email support", "Direct access to research notes"],
  isPopular: true,
  buttonText: "Select Premium",
  buttonVariant: "default" as const
}];
export default function InvestmentTiers() {
  return <section id="investment-tiers" className="bg-background text-foreground py-24 px-4 md:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-default font-bold mb-4">
            Investment Tiers
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Choose the level of insight that fits your trading style. Upgrade at
            any time to access our highest-conviction opportunities.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto items-start">
          {plans.map((plan, i) => <div data-index={i} key={plan.name} className="relative h-full">
              <Card className={`flex flex-col h-full transition-all duration-300 ${plan.isPopular ? "border-primary shadow-2xl shadow-primary/10 relative z-10 scale-100 md:scale-105" : "border-border/50 bg-card/50 hover:bg-card"}`}>
                <CardHeader className="text-center pb-2 relative">
                  {plan.isPopular && <div className="absolute -top-3 left-0 right-0 flex justify-center">
                      <Badge variant="default" className="bg-primary text-primary-foreground uppercase tracking-wider text-[10px] font-bold px-3 py-1">
                        Most Popular
                      </Badge>
                    </div>}
                  <CardTitle className="text-xl font-default mt-4">
                    {plan.name}
                  </CardTitle>
                  <CardDescription className="mt-2">
                    {plan.description}
                  </CardDescription>
                </CardHeader>

                <CardContent className="flex-grow flex flex-col">
                  <div className="text-center my-8">
                    <span className="text-5xl font-mono font-bold text-foreground">
                      {plan.price}
                    </span>
                    <span className="text-muted-foreground font-mono ml-1">
                      {plan.period}
                    </span>
                  </div>

                  <ul className="space-y-4 flex-grow">
                    {plan.features.map((feature, j) => <li data-index={j} key={j} className="flex items-start gap-3">
                        <Check className="size-5 text-emerald-500 shrink-0 mt-0.5" />
                        <span className="text-sm text-muted-foreground">
                          {feature}
                        </span>
                      </li>)}
                  </ul>
                </CardContent>

                <CardFooter className="pt-6">
                  <Button variant={plan.buttonVariant} className={`w-full h-12 text-base font-semibold ${plan.isPopular ? "bg-primary text-primary-foreground hover:bg-primary/90" : "border border-border/50"}`}>
                    {plan.buttonText}
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}